<div class="row m-0">
  <div class="col-lg-12 col-md-12 col-sm-12 p-0">
    <div class="side_padding_Warper">
      <div class="success_page_inner_center_Sec">
        <div class="back-btn text-left">
          <img
            class="back_icon_round"
            (click)="goBack()"
            src="../../../assets/img/back.svg"
            alt=""
          />
        </div>
        <div class="success_page_inner_body">
          <img src="../../../../../assets/img/sucess ful.svg" alt="" />
          <label>{{ title }}</label>
          <a (click)="viewDetails()" *ngIf="isShowViewDetailsLink">{{ viewDetailsLinkName }}</a>
          <div class="payment-detail" *ngIf="viewingPaymentDetail">
            <span
              >Amount: {{ dataService.currencySymbol }}
              {{ apiData?.amount }}</span
            >
            <span>Transaction Id: {{ apiData?.transactionId }}</span>
            <span
              >Date & Time:
              {{
                apiData?.transactionDateTime | date : "MM/dd/YYYY HH:mm:ss"
              }}</span
            >
          </div>
          <div
            class="btn_section d-flex align-items-center justify-content-between w-100"
          >
            <button
              type="button"
              class="border_btn mr-4"
              *ngIf="type === 'request-money'"
              (click)="cancelRequest()"
            >
              Cancel Request
            </button>
            <button type="button" class="btn" (click)="goBack()">Done</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
